// extracted by mini-css-extract-plugin
module.exports = {"navbarFriends":"NavbarFriends_navbarFriends__3BNP3","navbarFriendsHeader":"NavbarFriends_navbarFriendsHeader__1s5rw","navbarFriendsList":"NavbarFriends_navbarFriendsList__1MtAV"};